import { render, staticRenderFns } from "./ThanksContainer.vue?vue&type=template&id=0baabdbb&"
import script from "./ThanksContainer.vue?vue&type=script&lang=js&"
export * from "./ThanksContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports